var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio',{attrs:{"label":"1","border":""},model:{value:(_vm.flex),callback:function ($$v) {_vm.flex=$$v},expression:"flex"}},[_vm._v(" 横向滚动 ")]),_c('el-radio',{attrs:{"label":"2","border":""},model:{value:(_vm.flex),callback:function ($$v) {_vm.flex=$$v},expression:"flex"}},[_vm._v(" 纵向滚动 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }